import React, { useState, useEffect, useCallback } from 'react';
import {
  IconButton,
  Grid,
  Box,
  Typography,
  Divider,
  Button,
  MenuItem,
  InputLabel,
  FormControl,
  CircularProgress,
  FormControlLabel,
  Checkbox
} from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import Select from '@material-ui/core/Select';
import Alert from '@material-ui/lab/Alert';
import KeyboardReturnIcon from '@material-ui/icons/KeyboardReturn';

// components
import { useHistory, useParams } from 'react-router-dom';
import PageTitle from '../../components/PageTitle';
import Notification from '../../utils/notification';
import DeleteDialog from '../../components/DeleteDialog';
import Widget from '../../components/Widget/Widget';

import { useLayoutDispatch, toggleLoading } from '../../context/LayoutContext';
import { useUserState } from '../../context/UserContext';
import useStyles from './styles';
import api from '../../services/api';
import {
  cnpjMask, telefoneMask, cepMask, removeCaracteres
} from '../../utils/mask';
import { getError } from '../../utils/getResponseError';

export default function CadastroUsuario() {
  const history = useHistory();
  const classes = useStyles();
  const layoutDispatch = useLayoutDispatch();
  const { usuario } = useUserState();
  const [isSubmiting, setIsSubmiting] = useState(false);
  const [error, setError] = useState();
  const [data, setData] = useState({
    nome: '',
    email: '',
    senha: '',
    confirmaSenha: ''
  });

  const { id } = useParams();

  useEffect(() => {
    if (id) {
      getUsuario(id);
    }
  }, [id]);

  async function getUsuario(id) {
    toggleLoading(layoutDispatch);
    try {
      const { data: result } = await api.get(`/usuario/${id}`);
      setData(result);

      toggleLoading(layoutDispatch);
    } catch (error) {
      toggleLoading(layoutDispatch);
      Notification({
        type: 'report',
        message: getError(error),
        variant: 'contained',
        color: 'secondary',
      });
      history.push('/app/sistema/usuarios');
    }
  }

  async function handleSubmit(e) {
    e.preventDefault();

    if (data.senha !== '' && (data.senha !== data.confirmaSenha)) {
      return setError('A confirmação da senha deve ser igual a senha');
    }

    setIsSubmiting(true);
    try {
      const obj = {
        nome: data.nome,
        email: data.email,
        senha: data.senha
      };
      if (id) {
        await api.put(`usuario/${id}`, obj);
        Notification({
          type: 'shipped',
          message: 'Usuário atualizado',
          variant: 'contained',
          color: 'success',
        });
      } else {
        await api.post('usuario', obj);
        Notification({
          type: 'shipped',
          message: 'Usuário cadastrado',
          variant: 'contained',
          color: 'success',
        });
      }

      history.push('/app/sistema/usuarios');
    } catch (error) {
      setError(getError(error));
    }
    setIsSubmiting(false);
  }

  function handleChange(e) {
    const { name, value } = e.target;
    setData((old) => ({ ...old, [name]: value }));
  }

  return (
    <>
      <PageTitle
        title="Cadastro de usuários"
        button={(
          <IconButton
            color="primary"
            aria-label="cadastrar novo cliente"
            className={classes.addButton}
            onClick={() => history.push('/app/sistema/usuarios')}
          >
            <KeyboardReturnIcon />
          </IconButton>
        )}
      />
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <Widget disableWidgetMenu>
            <form autoComplete="off" onSubmit={handleSubmit}>
              <Grid container item xs={12}>
                <Grid item sm={12} xs={12}>
                  <Box px={3} pt={0} pb={0}>
                    <Typography variant="h5" color="textSecondary" noWrap>
                      Dados cadastrais
                    </Typography>
                    <Divider className={classes.divider} />
                  </Box>
                </Grid>
                <Grid item sm={6} xs={12}>
                  <Box px={3} py={2}>
                    <TextField
                      onChange={handleChange}
                      required
                      label="Nome"
                      fullWidth
                      value={data.nome}
                      name="nome"
                    />
                  </Box>
                </Grid>
                <Grid item sm={6} xs={12}>
                  <Box px={3} py={2}>
                    <TextField
                      onChange={handleChange}
                      required
                      label="Email"
                      fullWidth
                      value={data.email}
                      name="email"
                    />
                  </Box>
                </Grid>
                <Grid item sm={6} xs={12}>
                  <Box px={3} py={2}>
                    <TextField
                      onChange={handleChange}
                      required={!id}
                      label="Senha"
                      fullWidth
                      value={data.senha}
                      name="senha"
                      inputProps={{
                        minLength: 8,
                        type: 'password'
                      }}
                    />
                  </Box>
                </Grid>
                <Grid item sm={6} xs={12}>
                  <Box px={3} py={2}>
                    <TextField
                      onChange={handleChange}
                      required={!id}
                      label="Confirmação da senha"
                      fullWidth
                      value={data.confirmaSenha}
                      name="confirmaSenha"
                      inputProps={{
                        minLength: 8,
                        type: 'password'
                      }}
                    />
                  </Box>
                </Grid>
                <Grid container item xs={12}>
                  <Grid item xs={12} sm={8}>
                    <Box px={3} py={2} color="red">
                      {error && (
                        <Alert severity="error">{error}</Alert>
                      )}
                    </Box>
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <Box px={3} py={2} className={classes.botaoDireta}>
                      <Button
                        variant="contained"
                        color="primary"
                        type="submit"
                        disabled={isSubmiting}
                      >
                        {isSubmiting ? <CircularProgress size={25} /> : 'Salvar'}
                      </Button>
                    </Box>
                  </Grid>
                </Grid>
              </Grid>
            </form>
          </Widget>
        </Grid>
      </Grid>
    </>
  );
}
